import * as THREE from "three";
import { World } from "./World";
import {
    vSkyHatchShader, fSkyHatchShader,
    vDefaultShader, fBasicHatchingShader,
} from '../shaders/';


export class HiddenWolfWorld extends World {
    constructor({ name, model, assets }) {
        super({ name, model, assets });
        this.camera.near = 0.1;
        this.camera.far = 100;
        this.titleBrightness = 0.2;
        this.titleDisplace = 0.4;
        this.titleScale = 0.8;
    }

    processModel() {
        super.processModel();

        this.sky = this.model.scene.getObjectByName("sky");
        this.matSky = new THREE.ShaderMaterial({
            uniforms: {
                map: { value: this.sky.material.map },
                hatchingScale: { value: 20 },
                hatchingMap: { value: this.assets.textures.hatchC },
                gamma: { value: 1 },
                mixDiffuse: { value: 0 },
                whiteLevel: { value: 1 },
                blackLevel: { value: 0 },
                time: { value: 0 },
            },
            vertexShader: vSkyHatchShader,
            fragmentShader: fSkyHatchShader,
        })
        this.sky.material = this.matSky;

        const basicMat = new THREE.ShaderMaterial({
            uniforms: {
                map: { value: null },
                hatchingScale: { value: 20 },
                hatchingMap: { value: this.assets.textures.hatchC },
                gamma: { value: 1.8 },
                mixDiffuse: { value: 0 },
                whiteLevel: { value: 1.05 },
                blackLevel: { value: -.04 },
                time: { value: 0 },
            },
            vertexShader: vDefaultShader,
            fragmentShader: fBasicHatchingShader,
        })

        this.forest = this.model.scene.getObjectByName("forest");
        const forestMat = basicMat.clone()
        forestMat.uniforms.map.value = this.forest.material.map
        forestMat.uniforms.hatchingScale.value = 10
        this.forest.material = forestMat

        this.houses = this.model.scene.getObjectByName("houses");
        const housesMat = basicMat.clone()
        housesMat.uniforms.map.value = this.houses.material.map
        housesMat.uniforms.hatchingScale.value = 3
        housesMat.uniforms.gamma.value = 1
        this.houses.material = housesMat

        this.island = this.model.scene.getObjectByName("island");
        const islandMat = basicMat.clone()
        islandMat.uniforms.map.value = this.island.material.map
        islandMat.uniforms.hatchingScale.value = 8
        this.island.material = islandMat

        this.islandSide = this.model.scene.getObjectByName("islandSide");
        const islandSideMat = basicMat.clone()
        islandSideMat.uniforms.map.value = this.islandSide.material.map
        islandSideMat.uniforms.hatchingScale.value = 30
        this.islandSide.material = islandSideMat

        this.sheep = this.model.scene.getObjectByName("sheep");
        const sheepMat = basicMat.clone()
        sheepMat.uniforms.map.value = this.sheep.material.map
        sheepMat.uniforms.hatchingScale.value = 8
        this.sheep.material = sheepMat

        this.boy = this.model.scene.getObjectByName("Boy");
        const boyMat = basicMat.clone()
        boyMat.uniforms.map.value = this.boy.material.map
        boyMat.uniforms.hatchingScale.value = 4
        this.boy.material = boyMat
    }
}